import { VillaSearchNoResultPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result/villa-search-no-result.types";

export const useVillaSearchNoResult = (
  properties: VillaSearchNoResultPropertiesType
) => {
  const { query } = properties;

  return {
    resultTitle: "نتایج جستجو",
    notFoundtitle: "نتیجه ای یافت نشد.",
    firstDescription: (
      //TODO
      <>
        نتیجه‌ا‌ی برای ”
        <span className="text-on-surface-high-emphasis">{query}</span>” پیدا
        نکردیم.
      </>
    ),
    secondDescription: "با کلمه ی دیگری جستجو کنید."
  };
};
